import React from 'react'
import Modal from 'material-ui/Modal'
import Paper from 'material-ui/Paper'
import Button from 'material-ui/Button'
import Icon from 'material-ui/Icon'
import Typography from 'material-ui/Typography'

import EngGb from './components/englishGb'
import EngUs from './components/englishUs'
import Russian from './components/russian'
import Chinesse from './components/chinesse'
import German from './components/german'
import Spanish from './components/spanish'
import Italian from './components/italian'
import Portugesse from './components/portugesse'
import French from './components/french'

import { withStyles } from 'material-ui/styles'
import Grid from 'material-ui/Grid'

import styles from './styles'

import {
  ModalHeader,
  ModalContents,
  ModalFooter
} from '../../common/modal'


class TermsAndCondition extends React.Component {

  closeModal = () => {
    this.props.closeSignupModal()
  }

  renderBasedOnLanguage = (activeLanguage) => {
    if (activeLanguage === "en-US") {
      return <EngUs />
    } else if (activeLanguage === "zh-CN") {
      return <Chinesse />
    }
    else if (activeLanguage === "de-DE") {
      return <German />
    }
    else if (activeLanguage === "fr-FR") {
      return <French />
    }
    else if (activeLanguage === "it-IT") {
      return <Italian />
    }
    else if (activeLanguage === "pt-PT") {
      return <Portugesse />
    }
    else if (activeLanguage === "es-ES") {
      return <Spanish />
    }
    else if (activeLanguage === "ru-RU") {
      return <Russian />
    } else {
      return <EngGb />
    }
  }

  render() {

    const { classes, open, closeSignupModal, activeLanguage, translate } = this.props
    return (
      <Modal
        open={open}
        onClose={this.closeSignupModal}
      >
        <div className={classes.root}>
          <Paper className={classes.modal}>
            <ModalHeader>
              <Typography type="headline" color="inherit" className={classes.modalHeader}>
               {translate('header_terms_condition')}
              </Typography>
              <Button
                className={classes.close}
                onClick={() => closeSignupModal()}
              >
                <Icon>clear</Icon>
              </Button>
            </ModalHeader>

            <ModalContents>
              <Grid container spacing={8} className={classes.form}>
                {this.renderBasedOnLanguage(activeLanguage)}
              </Grid>
            </ModalContents>

          </Paper>
        </div>
      </Modal>
    )
  }

}

export default withStyles(styles)(TermsAndCondition)
